"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProjectionClient = void 0;
const model_client_1 = require("../../model-client");
class SearchProjectionClient extends model_client_1.ModelClient {
    getModelName() {
        return 'search-projection';
    }
    getVersion() {
        return 'v1';
    }
    isPublic() {
        return false;
    }
}
exports.SearchProjectionClient = SearchProjectionClient;
//# sourceMappingURL=search-projection-client.js.map